import { useState } from 'react'
import classnames from 'classnames'
import { yieldToMain } from '@/root/utils/yield-to-main'

interface RangeSliderProps {
  name: string
  min: number
  max: number
  step: number
  units: string
  valuePrefix: string
  defaultValue?: number
  className?: string
  onChangeRange?: (val: number | string) => void
  valueClassNames?: string
  showMinInsteadOfVal?: boolean
}
const RangeSlider = ({
  name,
  min,
  max,
  step,
  units,
  valuePrefix,
  defaultValue,
  className = '',
  valueClassNames,
  showMinInsteadOfVal = false,
  onChangeRange = () => null,
}: RangeSliderProps) => {
  const [value, setValue] = useState(defaultValue ?? min)
  return (
    <label htmlFor={name}>
      <input
        type="range"
        className={classnames(
          ' bg-brand-grey-background h-2 w-full cursor-pointer rounded border-0 focus:ring-0',
          {
            [className]: className,
          },
        )}
        min={min}
        max={max}
        value={value}
        step={step}
        name={name}
        id={name}
        onChange={async e => {
          setValue(Number(e.target.value))
          await yieldToMain()
          onChangeRange(e.target.value)
        }}
      />
      <div className="flex">
        <div className={valueClassNames}>{`${valuePrefix}${
          showMinInsteadOfVal ? min : value
        }${units}`}</div>
        <div className="text-brand-grey-base w-full text-right text-xs">{`${valuePrefix}${max}${units}`}</div>
      </div>
    </label>
  )
}

export default RangeSlider
